import { Component, _decorator } from 'cc';
import NumberFormatter from '../../../../../common/scripts/Toolkit/Components/Label/NumberFormatter';
import MultiThemeColor from '../../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeColor';

const { ccclass, requireComponent, executeInEditMode } = _decorator;
const ZERO_THEME = 0;
const LARGE_THAN_ZERO_THEME = 1;
const LESS_THAN_ZERO_THEME = 2;

@ccclass('WinNumber')
@executeInEditMode
@requireComponent([NumberFormatter, MultiThemeColor])
export default class WinNumber extends Component {
    private _multiThemeColor: MultiThemeColor = null;
    private _numberFormatter: NumberFormatter = null;

    private get multiThemeColor() {
        if (!this._multiThemeColor) {
            this._multiThemeColor = this.getComponent(MultiThemeColor);
        }
        return this._multiThemeColor;
    }

    private get numberFormatter() {
        if (!this._numberFormatter) {
            this._numberFormatter = this.getComponent(NumberFormatter);
        }
        return this._numberFormatter;
    }

    protected onLoad() {
        this.numberFormatter.on(NumberFormatter.EVENT_TYPE.VALUE_CHANGED, this._updateNumber, this);
    }

    protected start() {
        this._updateNumber();
    }

    private _updateNumber() {
        const { value } = this.numberFormatter;
        if (value === 0) {
            this.multiThemeColor.theme = ZERO_THEME;
            this.numberFormatter.textTemplate = '';
        } else if (value > 0) {
            this.multiThemeColor.theme = LARGE_THAN_ZERO_THEME;
            this.numberFormatter.textTemplate = '+{0}';
        } else {
            this.multiThemeColor.theme = LESS_THAN_ZERO_THEME;
            this.numberFormatter.textTemplate = '';
        }
        this.numberFormatter.updateTextDisplay();
    }
}
